import { useQuoteContext } from '../../../hooks/useQuoteContext'
import useFeaturePermissions from '../../../hooks/useFeaturePermissions'

export default function PayrollFirstPayDateRow() {
   const state = useQuoteContext()
   const { getString } = state
   const { hasPermission } = useFeaturePermissions()

   if (!hasPermission('PayrollFirstPayDate', state.user_role)) return <></>
   const sfEINCount = state.accountSnowflake?.EINs__c?.[0]?.length ?? 0
   const hasNewEINs = state.differenceQuote
      ? state.productPayrollEINCount > sfEINCount
      : state.productPayrollEINCount > 0
   if (!hasNewEINs) return <></>

   const displayValue = state.payrollFirstPayDate ?? state.activationDate ?? ''

   let maxDate: string | undefined
   if (!hasPermission('UnlimitedPayrollFirstPayDate', state.user_role)) {
      if (state.timeData?.currentDate) {
         const [y, m, d] = state.timeData.currentDate.split('-').map(Number)
         const sixMonthsFromNow = new Date(y, m - 1, d)
         sixMonthsFromNow.setMonth(sixMonthsFromNow.getMonth() + 6)
         const my = sixMonthsFromNow.getFullYear()
         const mm = String(sixMonthsFromNow.getMonth() + 1).padStart(2, '0')
         const md = String(sixMonthsFromNow.getDate()).padStart(2, '0')
         maxDate = `${my}-${mm}-${md}`
      }
   }

   return (
      <div className='row'>
         <div className='col-bhr1'>
            {getString(
               'product.ToolbarPayrollFirstPayDate.InputText',
               'First Pay Date',
            )}
         </div>
         <div className='col-bhr2'>
            <input
               className='form-control'
               type='date'
               value={displayValue}
               min={state.activationDate ?? undefined}
               max={maxDate}
               onChange={state.onPayrollFirstPayDateChange}
            />
         </div>
         <div className='col'></div>
         <div className='col'></div>
         <div className='col'></div>
         <div className='col'></div>
         {state.differenceQuote && (
            <>
               <div className='col col-bhr-blue'></div>
               <div className='col'></div>
            </>
         )}
      </div>
   )
}
